import React from "react";
import Media from "@qlik/qlik/src/components/Media";
import { filterValidCta, getCardBodyContent } from "@qlik/qlik/src/lib/util/helpers";
import Cta from "@qlik/qlik/src/components/Cta";
import * as styles from "./styles.module.css";

/**
 * CardBio component.
 * Renders a card with a title, subtitle, image, cta, and body.
 * @param {Object} props - The component props.
 * @param {Object} props.data - The data for the card.
 * @param {Object} props.data.cardItem - The card item data.
 * @param {string} props.data.cardItem.title - The title of the card.
 * @param {string} props.data.cardItem.subtitle - The subtitle of the card.
 * @param {Object} props.data.cardItem.media - The media for the card.
 * @param {Object} props.data.cardItem.cta - The cta for the card.
 * @param {string} props.data.cardItem.body - The body of the card.
 */
const CardBio = ({ data, className }) => {
    const {
        cardItem: { title, subtitle, media, cta },
        customId,
    } = data ?? {};
    const customClassNames = className ?? ""; // pass custom class
    const ctaList = filterValidCta(cta);
    const bodyContent = getCardBodyContent(data?.cardItem);

    return (
        <section className={`py-15 lg:py-30 ${customClassNames}`} id={customId}>
            <div className="container">
                <div className="flex flex-wrap gap-7.5 lg:flex-nowrap lg:gap-15">
                    <div className="flex flex-col flex-1 gap-3.75 lg:max-w-92.5 lg:gap-7.5 items-center justify-start">
                        {media?.[0] && (
                            <div className="w-full rounded overflow-hidden">
                                <Media
                                    media={media[0]}
                                    className="object-cover w-full max-h-90 h-auto max-w-full lg:max-h-full"
                                />
                            </div>
                        )}
                        {ctaList?.length > 0 && (
                            <div className="mx-auto flex flex-wrap gap-3.75 lg:gap-7.5">
                                {ctaList?.map((linkData) => (
                                    <Cta
                                        key={linkData.id}
                                        className="rounded-full bg-white p-3.75 w-[45px] h-[45px] shadow-mdLight"
                                        data={linkData}
                                    >
                                        <Media
                                            link={linkData.icon?.[0]?.secure_url}
                                            alt={linkData.text}
                                            className="w-full h-auto object-cover"
                                        />
                                    </Cta>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="lg:flex-1">
                        {title && <h1 className="title-1 text-left mb-4.5">{title}</h1>}
                        {subtitle && <p className="text-2xl leading-snug tracking-tight5 font-light">{subtitle}</p>}
                        {bodyContent && <div className={`mt-8 ${styles.bodyContent}`}>{bodyContent}</div>}
                    </div>
                </div>
            </div>
        </section>
    );
};
export default CardBio;
